"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _CircularProgress = _interopRequireDefault(require("../CircularProgress"));
var _TextField = _interopRequireDefault(require("./TextField"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["type", "value", "helper", "onChange", "label", "error", "name", "variant", "affix", "suffix", "disabled", "loading", "InputProps", "inputRef"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var GgTextField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var type = _ref.type,
    value = _ref.value,
    helper = _ref.helper,
    onChange = _ref.onChange,
    label = _ref.label,
    error = _ref.error,
    name = _ref.name,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'outlined' : _ref$variant,
    affix = _ref.affix,
    suffix = _ref.suffix,
    disabled = _ref.disabled,
    loading = _ref.loading,
    _ref$InputProps = _ref.InputProps,
    receiveInputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    inputRef = _ref.inputRef,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = function handleChange(e) {
    onChange(e, e.target.value);
  };
  var InputProps = _objectSpread({}, receiveInputProps);
  if (affix) {
    InputProps.startAdornment = affix;
  }
  if (suffix) {
    InputProps.endAdornment = suffix;
  }
  if (loading) {
    InputProps.endAdornment = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress["default"], {
      size: 'small'
    });
  }
  if (!InputProps.form) {
    InputProps.form = {};
  }
  InputProps.form.autocomplete = 'off';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField["default"], _objectSpread({
    ref: ref,
    size: 'small',
    variant: variant,
    disabled: disabled,
    name: name,
    label: label,
    error: !!error,
    value: value !== undefined ? value : '',
    onChange: onChange && handleChange,
    type: type,
    helperText: error || helper,
    InputProps: InputProps,
    "data-cy": name,
    inputRef: inputRef
  }, props));
});
GgTextField.propTypes = {
  /**
   * 	The contents of the form control.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].array, _propTypes["default"].func]),
  /**
   * 	Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * The color of the component.
   * It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary']),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes["default"].elementType,
  /**
   * If true, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: _propTypes["default"].bool,
  /**
   * If true, the label should be displayed in an error state.
   */
  error: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /**
   * If true, the component will be displayed in focused state.
   */
  focused: _propTypes["default"].bool,
  /**
   * If true, the component will take up the full width of its container.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * If true, the label will be hidden. This is used to increase density for a FilledInput.
   * Be sure to add data-cy-label to the input element.
   */
  hiddenLabel: _propTypes["default"].bool,
  /**
   * If dense or normal, will adjust vertical spacing of this and contained components.
   */
  margin: _propTypes["default"].oneOf(['dense', 'none', 'normal']),
  /**
   * If true, the label will indicate that the input is required.
   */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  required: _propTypes["default"].bool,
  /**
   * 	The size of the text field.
   */
  size: _propTypes["default"].oneOf(['medium', 'small']),
  /**
   * The variant to use.
   */
  variant: _propTypes["default"].oneOf(['filled', 'outlined', 'standard']),
  FormHelperTextProps: _propTypes["default"].object,
  InputLabelProps: _propTypes["default"].object,
  fixAutoComplete: _propTypes["default"].bool,
  range: _propTypes["default"].bool,
  debounceTimeout: _propTypes["default"].number,
  inputRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })]),
  helper: _propTypes["default"].string,
  loading: _propTypes["default"].bool,
  affix: _propTypes["default"].node,
  suffix: _propTypes["default"].node,
  InputProps: _propTypes["default"].object,
  type: _propTypes["default"].oneOf(['number', 'password', 'text', 'email', 'percent', 'currency', 'days'])
};
var _default = exports["default"] = GgTextField;